<template>
  <!--container-->
  <div class="Background">

    <h2 class="Title">
      Upload Option
    </h2>

    <!--table card-->
    <v-card elevation="0">



      <!--table-->

      <v-col class="ml-5">
        <v-radio-group v-model="uploadOption" inline row>
          <v-radio color="black" class="mt-5 pr-5 mr-5" v-for="radio in uOptions" :key="radio.value"
            :label="radio.label" :value="radio.value"></v-radio>
        </v-radio-group>
      </v-col>


    </v-card>

    <v-row justify="end">
      <v-btn :disabled="dialog" :loading="dialog" dark elevation="0" @click="changeRadioSelected">
        SAVE
      </v-btn>
    </v-row>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

    <!--end-->
  </div>
</template>

<script>
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import { mapGetters, mapActions } from 'vuex';


export default {
  computed: {
    ...mapGetters('user', ['upload']),
    uploadOption: {
      get() {
        return this.upload;
      },
      set(value) {
        this.setUploadOption(value);
      }
    }

  },
  components: {
    AppSnackbar
  },
  data() {
    return {
      dialog: false,
      uOptions: [
        { label: '업로드 퍼블리싱', value: 2 },
        { label: '업로드 + 인코딩/퍼블리싱 진행', value: 1 },
      ],
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
    }
  },
  methods: {
    ...mapActions('user', ['changeUploadOption']),
    async changeRadioSelected() {
      const response = await this.changeUploadOption(this.uploadOption);

      if (response.success) {
        this.snackbarText = '변경 성공';
        this.snackbarError = false;
        this.snackbar = true;
      } else {
        this.snackbarText = 'Error';
        this.snackbarError = true;
        this.snackbar = true;
      }

      setTimeout(() => {
        this.snackbar = false;
        this.snackbarError = false;
      }, 10000);
    },
    setUploadOption(value) {
      this.$store.commit('user/setUpload', value);
    },
  }
}
</script>

<style scoped>
/* .drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
} */

.drop-area p {
  margin: 0;
}


.hovered-card {
  background-color: #f0f0f0;
  /* 호버 상태에서의 배경 색상 설정 */
}


.centered-text {
  line-height: 100px;
  font-size: 20px;
  color: #d7d7d7
}

.dotted-outline-card {
  border: 2px dashed #e3e3e3;
  /* 점선 아웃라인 스타일의 테두리와 색상 설정 */
  transition: background-color 0.3s;
}

.custom-data-table>>>.v-data-table__wrapper table tbody tr td {
  font-size: 13px;
}
</style>